import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import { GameProvider } from './GameContext';

// The game's main module. Importing it loads the whole game; renderGame()
// puts it on screen. The Gate 1 trial build (src/gate1/main.js) imports it
// without rendering, so its cold start carries the game's JavaScript weight.
export function renderGame() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <GameProvider>
          <App />
        </GameProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}
